var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addMember" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "welcomeDia treeDia",
          staticStyle: { "margin-top": "0vh" },
          attrs: {
            title: _vm.title,
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "667px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            },
            close: _vm.closeTree
          }
        },
        [
          !_vm.openOrCloseStatus
            ? _c("div", { staticClass: "data-wrap" }, [
                _c("div", { staticClass: "tree-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "head-left" },
                    [
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: "搜索成员或部门",
                          "suffix-icon": "el-icon-search",
                          size: "mini",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filterText,
                          callback: function($$v) {
                            _vm.filterText = $$v
                          },
                          expression: "filterText"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "tree-data" },
                    [
                      _c("el-tree", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "codeTree",
                        attrs: {
                          data: _vm.treeData,
                          "filter-node-method": _vm.filterNode,
                          "default-checked-keys": _vm.checkedKeys,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-expanded-keys": _vm.defaultShowNodes,
                          "render-after-expand": false,
                          "expand-on-click-node": true
                        },
                        on: { "check-change": _vm.checkChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var node = ref.node
                                var data = ref.data
                                return _c(
                                  "div",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c("i", [
                                      data.hasChildren
                                        ? _c("img", {
                                            staticClass: "icon-style",
                                            attrs: {
                                              src: require("@/assets/staffTree/department.png"),
                                              alt: ""
                                            }
                                          })
                                        : _c("img", {
                                            staticClass: "icon-style",
                                            attrs: {
                                              src: require("@/assets/staffTree/staff.png"),
                                              alt: ""
                                            }
                                          })
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "node-item",
                                        attrs: {
                                          title: data.hasChildren
                                            ? data.departmentName
                                            : data.userName
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "content" }, [
                                          _vm._v(
                                            _vm._s(
                                              data.hasChildren
                                                ? data.departmentName
                                                : data.userName
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    data.hasChildren
                                      ? _c("i", [
                                          _c("img", {
                                            staticClass: "btn-icon",
                                            class: node.expanded
                                              ? "btn-icon2"
                                              : "",
                                            attrs: {
                                              src: require("@/assets/staffTree/arrow.png"),
                                              alt: ""
                                            }
                                          })
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          2360734006
                        )
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "split-line" }),
                _c(
                  "div",
                  {
                    staticClass: "selected-wrap",
                    attrs: { id: "selectedWrap" }
                  },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("div", { staticClass: "selected-title" }, [
                        _vm._v(_vm._s("已选成员"))
                      ]),
                      _c(
                        "div",
                        { staticClass: "selet-name-wrap" },
                        _vm._l(_vm.currentIdName, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "select-right" },
                            [
                              _c("span", { staticClass: "name-left" }, [
                                item.type == "depart"
                                  ? _c("img", {
                                      staticClass: "icon-style",
                                      attrs: {
                                        src: require("@/assets/staffTree/department.png"),
                                        alt: ""
                                      }
                                    })
                                  : _c("img", {
                                      staticClass: "icon-style",
                                      attrs: {
                                        src: require("@/assets/staffTree/staff.png"),
                                        alt: ""
                                      }
                                    }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "select-name",
                                    attrs: { title: item.name }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              ]),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function($event) {
                                    return _vm.clickCurrrntFn(item, false)
                                  }
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm.openOrCloseStatus
            ? _c("div", { staticClass: "empty-wrap" }, [
                _c("div", { staticClass: "tip" }, [
                  _vm._v("暂无启用账号权限的员工")
                ])
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeTree } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: _vm.btnDisable
                  },
                  on: { click: _vm.clickSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }